import React from 'react';

function Hero() {
  return (
    <section className="hero-section">
      <div className="container hero-content">
        <h1>Homesteadr | Smart AI Gardening & Local Produce Marketplace</h1>
        <p className="subtitle" style={{ fontSize: '1.25rem', lineHeight: '1.6', marginTop: '16px' }}>
          <strong>Homesteadr</strong> is an all-in-one agricultural management application and local peer-to-peer farmers market. Design interactive garden plot layouts, analyze hyper-local microclimates with AI, optimize crop yields, and buy or sell fresh homegrown produce with your neighbors.
        </p>
      </div>
      {/* Optional: Add a background image via CSS or an img tag here */}
      {/* <img src="/images/hero-background.jpg" alt="Garden illustration" className="hero-background-image" /> */}
    </section>
  );
}

export default Hero;
